import {PROJECT_TREE, PROJECT_TREE_ERROR, PROJECT_TREE_SUCCESS } from './constants';

export default function projectTreeReducer(state, action) {
	let multi = [];
	let multimod = '';
	let datasource = '';
	let multiple = [];
	let single = [];
	let imageclassification;
	let imageclassificationenabled = false;
	
	switch (action.type) {
	case PROJECT_TREE:
		return { ...state, pending: true };
	
	case PROJECT_TREE_SUCCESS:
		if (action.payload) {
			single.push(action.payload.single);
			multiple.push(action.payload.multiple);
			multi.push(action.payload.multi);
			multimod = action.payload.modelpredictlevel ? action.payload.modelpredictlevel : 'N/A';
			datasource = action.payload.datasource ? action.payload.datasource : 'N/A';
			imageclassification = action?.payload?.Imageclassification ? action.payload.Imageclassification : [];
			imageclassificationenabled = action?.payload?.imageclassificationenabled ? action.payload.imageclassificationenabled : false;
		
			return { ...state, multi : multi, multiple : multiple, single : single, multimod : multimod, datasource : datasource,  pending: false, error: false, imageclassification, imageclassificationenabled : imageclassificationenabled };
		} else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, multimod: [], pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}

	case PROJECT_TREE_ERROR:
		return { ...state, pending: false, error: true };

	
	
	
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}